import { Button } from '@kizen/kds/Button';
import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import BasicModal from '__components/Modals/presets/BasicModal';
import useModal from '__components/Modals/useModal';
import { useTranslation } from 'react-i18next';

type InlineImportProps = {
  onImport: () => Promise<unknown>;
  onSkip: () => Promise<unknown>;
  pending?: boolean;
  alreadyImported?: boolean;
  inModal?: boolean;
};

export const InlineImport = (props: InlineImportProps) => {
  const { onImport, onSkip, pending, alreadyImported, inModal } = props;
  const { t } = useTranslation();

  const [confirmSkipModalProps, , confirmSkipModal] = useModal({});

  return (
    <>
      <Typography>
        {t(
          'This app has a Kizen schema available to import. If you proceed, your business will be updated with the new schema. If the app is later uninstalled, these changes will remain.'
        )}
      </Typography>
      <Spacer size={20} />
      <div className={inModal ? 'flex justify-end pb-[10px]' : 'flex'}>
        {!alreadyImported ? (
          <>
            <Button
              variant="text"
              color="warning"
              onClick={confirmSkipModal.show}
              disabled={pending}
            >
              {t('Skip for now')}
            </Button>
            <Spacer size={10} />
          </>
        ) : null}
        <Button onClick={onImport} disabled={pending}>
          {alreadyImported ? t('Re-Import Schema') : t('Import Schema')}
        </Button>
      </div>
      <BasicModal
        heading={t('Skip Import')}
        buttonText={t('Continue Without Importing')}
        defaultLeftBtnText={t('Go Back')}
        {...confirmSkipModalProps}
        onConfirm={onSkip}
      >
        <Typography>
          {t(
            'If you choose to skip importing, you may need to create custom objects or other assets to support this app. You may import at a later time if you wish. Would you like to continue?'
          )}
        </Typography>
        <Spacer size={5} />
      </BasicModal>
    </>
  );
};
